// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"11":"month-of-statement","398":"appointment","425":"meter-reading","836":"consumption","922":"unsubscribe","962":"home"}[chunkId] + "." + {"11":"f540da2c","398":"c7da815c","425":"0dfc4b7c","836":"214bef52","922":"f540da2c","962":"c423da4b"}[chunkId] + ".css";
};